/** @format */

import React from 'react';
import { connect } from 'react-redux';
import { Routes, Route, matchPath } from 'react-router-dom';
import Layout from 'src/ui/layout';
import {
  QuestionnaireLandingContainer,
  QuestionnaireSectionContainer,
  QuestionnairePageContainer,
  QuestionnaireCompleteContainer,
} from './containers';
import { updateBodyClass } from 'src/helpers';
//import { unlockQuestionnaire } from 'src/services/cms.service.js';
import CasesDetailsBarPres from 'src/ui/features/Cases/presentational/CasesDetailsBarPres';

import { resetQuestionnaire } from 'src/ui/features/Questionnaire/state/questionnaireActions';
import {
  QUESTIONNAIRE_LANDING_URL,
  QUESTIONNAIRE_SECTION_URL,
  QUESTIONNAIRE_PAGE_URL,
  QUESTIONNAIRE_COMPLETE_URL,
  BODY_CLASSES,
  CASE_DETAIL_QUESTIONNAIRE_LANDING_URL,
  CASE_DETAIL_QUESTIONNAIRE_SECTION_URL,
} from 'src/constants/constants.js';

import {
  getCaseMessagesCountsPending,
  getChaseFrequency,
  getExperianResults,
  getExperianBgCheckResults,
  getExperianPDF,
  storeCaseDetails,
} from 'src/ui/features/Cases/state/casesActions.js';

import { fetchDetailsHeader, fetchCaseQuestionnaireList } from 'src/services/cases.service';
import { getDocumentsAPI } from 'src/services/documents.service';
import withRouter from 'src/utils/withRouter';

const QuestionnaireLandingContainerWithRouter = withRouter(QuestionnaireLandingContainer);
const QuestionnaireSectionContainerWithRouter = withRouter(QuestionnaireSectionContainer);
const QuestionnairePageContainerWithRouter = withRouter(QuestionnairePageContainer);
const QuestionnaireCompleteContainerWithRouter = withRouter(QuestionnaireCompleteContainer);

class QuestionnaireRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.QUESTIONNAIRE);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.QUESTIONNAIRE);

    //const { location, personId } = this.props;
    const { location } = this.props;
    const params = location.pathname.split('/');

    if (params.length && params[2]) {
      let assigneeValue = params[2];
      // when coming out of cases/detail the params url is different
      if (params[1] === 'cases' && params[2] === 'detail') {
        assigneeValue = params[5];
      }
      // when a user leaves the questionnaire we must unlock the inprogress questionnaire
      // Comment the savegoaccess API as per update from Bussiness team
      // unlockQuestionnaire(personId, assigneeValue);
      this.props.resetQuestionnaire();
    }
  }

  getDetails = async () => {
    const {
      //  getCaseMessagesCountsPending,
      storeCaseDetails,
      //   getChaseFrequency,
      //  getExperianResults,
      //    getExperianBgCheckResults,
      // getExperianPDF,
    } = this.props;
    const caseManagerId = sessionStorage.getItem('caseManagerId');

    const config = {
      pageSize: 25,
      pageNumber: 1,
      caseManagerId,
    };
    const [detailsHeaderResult] = await Promise.all([
      fetchDetailsHeader(caseManagerId),
      fetchCaseQuestionnaireList(caseManagerId),
      getDocumentsAPI(config),
    ]);

    if (detailsHeaderResult && detailsHeaderResult.success && detailsHeaderResult.messages) {
      storeCaseDetails(detailsHeaderResult.messages);
      sessionStorage.setItem('headerDetails', JSON.stringify(detailsHeaderResult.messages));
      sessionStorage.setItem('clientId', JSON.stringify(detailsHeaderResult.messages.clientId));
    }

    try {
      getChaseFrequency();
      getCaseMessagesCountsPending();
      getExperianResults(caseManagerId);
      getExperianBgCheckResults(caseManagerId);
      getExperianPDF(caseManagerId);
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const headerDetails = this.props.headerDetails;
    const { location } = this.props;
    const isLandingPage = !!matchPath({ path: QUESTIONNAIRE_LANDING_URL, end: true }, location.pathname);
    return this.props.isWithinCaseDetails ? (
      <div className="case-details-questionnaire-container">
        <Routes>
          <Route
            index
            element={<QuestionnaireLandingContainerWithRouter {...this.props} />}
          />
          <Route
            path={':sectionName'}
            element={<QuestionnaireSectionContainerWithRouter {...this.props} />}
          />
        </Routes>
      </div>
    ) : (
      <Layout headerName={'Questionnaire'}>
        {headerDetails && (
          <CasesDetailsBarPres
            frequencyList={this.props.frequencyList}
            {...this.props}
            isEYPro={true}
            onRefreshDetails={this.getDetails}
            showHistoryBack={isLandingPage}
            headerDetails={headerDetails}></CasesDetailsBarPres>
        )}
        <Routes>
          <Route path={':assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId'} element={<QuestionnaireLandingContainerWithRouter />} />
          <Route path={':assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId/:sectionName'} element={<QuestionnaireSectionContainerWithRouter />} />
          <Route path={':assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId/:sectionName/:pageId'} element={<QuestionnairePageContainerWithRouter />} />
          <Route path={':assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId/:sectionName/:pageId/complete'} element={<QuestionnaireCompleteContainerWithRouter />} />
        </Routes>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  personId: state.login.userInfo.personId,
  frequencyList: state.cases.frequencyList,
  headerDetails: state.cases.caseDetails,
});

const mapDispatchToProps = {
  resetQuestionnaire,
  storeCaseDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireRoot);
